<script setup lang="ts">
import { computed } from 'vue'
import { useShop } from '@/composables/game/shop'

// Import all badge images
import DefaultBOGOBadgeImage from '@/assets/images/periodic/default-BOGO/default-BOGO-badge.png'
import DefaultBOGXBadgeImage from '@/assets/images/periodic/default-BOGX/default-BOGX-badge.png'
import DefaultDiscountBadgeImage from '@/assets/images/periodic/default-discount/default-discount-badge.png'
import DefaultCashbackBadgeImage from '@/assets/images/periodic/default-cashback/default-cashback-badge.png'
import IWDBadgeImage from '@/assets/images/periodic/IWD/IWD-badge.png'
import STPBadgeImage from '@/assets/images/periodic/STP/STP-badge.png'

export type BadgeVariant = 'BOGO' | 'BOGX' | 'discount' | 'cashback' | 'IWD' | 'STP'

const props = defineProps<{
	variant: BadgeVariant
}>()

const { saleName } = useShop()

const badgeImage = computed(() => {
  const imageMap: Record<BadgeVariant, string> = {
    'BOGO': DefaultBOGOBadgeImage,
    'BOGX': DefaultBOGXBadgeImage,
    'discount': DefaultDiscountBadgeImage,
    'cashback': DefaultCashbackBadgeImage,
    'IWD': IWDBadgeImage,
    'STP': STPBadgeImage,
  }
  return imageMap[props.variant]
})
</script>
<template>
  <div class="flex">
    <div class="relative flex items-center justify-center h-full w-full">
      <img
        :src="badgeImage"
        class="h-full w-auto block"
      >
      <div class="absolute rotate-[-24deg] top-1/2 left-1/2 translate-x-[calc(-50%)] translate-y-[calc(-50%)] w-full overflow-visible">
        <span class="black-stroke-golden-text badge-text uppercase font-[800] text-[9.6px] leading-[9px] whitespace-pre-line w-full overflow-visible inline-block h-max text-center">{{ saleName }}</span>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
@import '@/assets/styles/sales';
</style>
